import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let allInputs = this.el.querySelectorAll('.o-form .o-input, .o-form .o-textarea')

        Array.prototype.slice.call(allInputs)
            .forEach(function (nodeInput) {
                nodeInput.addEventListener('focusout', function (ev) {
                    if (nodeInput.value.length > 0) {
                        nodeInput.classList.add('-input-filled')
                    } else {
                        nodeInput.classList.remove('-input-filled')
                    }
                })
            })
    }
}
